import { Route, Switch } from "wouter";
import AllwayswithyouLanding from "./AllwayswithyouLanding";
import BlogPage from "./BlogPage";
import BlogPost from "./BlogPost";
import LegalPage from "./LegalPage";

function App() {
  return (
    <Switch>
      <Route path="/">
        <AllwayswithyouLanding />
      </Route>
      <Route path="/blog">
        <BlogPage />
      </Route>
      <Route path="/blog/:slug">
        <BlogPost />
      </Route>
      <Route path="/privacy-policy">
        <LegalPage />
      </Route>
      <Route path="/terms-conditions">
        <LegalPage />
      </Route>
      <Route path="/cookie-policy">
        <LegalPage />
      </Route>
      <Route path="/company-info">
        <LegalPage />
      </Route>
      <Route>
        <AllwayswithyouLanding />
      </Route>
    </Switch>
  );
}

export default App;
